<template>
  <main class="flex flex-col bg-white rounded">
    <div
      class="flex items-center gap-3 border-t-4 border-t-blue-500 rounded-t border-b p-3"
    >
      <button
        v-if="isRoute === '/admin/yellow/meeting-users'"
        @click="closeEdit()"
        class="bg-blue-500 p-2 text-white text-xs rounded hover:bg-blue-600"
      >
        <font-awesome-icon icon="fa-solid fa-angles-left" class="mr-1" />
        Буцах
      </button>
      <h6 class="text-base">
        {{ !form.id ? "Хэрэглэгч нэмэх" : "Хэрэглэгч засах" }}
      </h6>
    </div>

    <div class="p-3 space-y-5">
      <div class="flex gap-10">
        <div class="w-full">
          <label for="nameMn"
            >Байгууллага / Хувь хүний нэр /монголоор/:<span class="text-red-500"
              >*</span
            ></label
          >
          <input
            id="nameMn"
            name="nameMn"
            type="text"
            placeholder="Нэр"
            class="w-full p-2 border"
            v-model="form.name"
          />
        </div>

        <div class="w-full">
          <label for="nameEn"
            >Байгууллага / Хувь хүний нэр /англиар/:<span class="text-red-500"
              >*</span
            ></label
          >
          <input
            id="nameEn"
            name="nameEn"
            type="text"
            placeholder="Нэр"
            class="w-full p-2 border"
            v-model="form.name_en"
          />
        </div>
      </div>

      <div class="flex gap-10">
        <div class="w-full">
          <label for="email"
            >Цахим шуудан:<span class="text-red-500">*</span></label
          >
          <input
            id="email"
            name="email"
            type="text"
            placeholder="Цахим шуудан"
            class="w-full p-2 border"
            v-model="form.email"
          />
        </div>

        <div class="w-full">
          <label for="phone_number"
            >Утасны дугаар:<span class="text-red-500">*</span></label
          >
          <input
            id="phone_number"
            name="phone_number"
            type="text"
            placeholder="Нэр"
            class="w-full p-2 border"
            v-model="form.phone_number"
          />
        </div>
      </div>

      <div class="w-full">
        <label for="user_type">Төрөл:<span class="text-red-500">*</span></label>
        <select
          name="user_type"
          id="user_type"
          class="w-full border p-2"
          v-model="form.user_type"
        >
          <option disabled value="">Төрөл</option>
          <option value="Exhibitor">Exhibitor</option>
          <option value="Sponsor">Sponsor</option>
          <option value="Attendee">Attendee</option>
        </select>
      </div>

      <div class="flex justify-center">
        <button @click="addUser" class="bg-blue-500 text-white p-2 group">
          <font-awesome-icon
            icon="fa-solid fa-plus"
            class="mr-1 transition-transform duration-300 group-hover:rotate-90"
          />
          {{ !form.id ? "Нэмэх" : "Засах" }}
        </button>
      </div>
    </div>
  </main>

  <SuccessModal v-if="success" :success="success" />
  <ErrorModal v-if="error" :error="error" />
</template>

<script>
import adminInstance from "@/lib/adminInstance";
import { ref, onMounted } from "vue";
import SuccessModal from "@/components/ui/SuccessModal.vue";
import ErrorModal from "@/components/ui/ErrorModal.vue";
import { useRoute } from "vue-router";

export default {
  name: "YellowEditMeetingUser",
  components: {
    SuccessModal,
    ErrorModal,
  },
  props: {
    data: Object,
  },
  emits: ["closeEdit"],
  setup(props, { emit }) {
    const closeEdit = () => {
      resetForm();
      emit("closeEdit");
    };

    const route = useRoute();
    const isRoute = ref(route.path);

    const form = ref({
      id: null,
      name: null,
      name_en: null,
      email: null,
      phone_number: null,
      user_type: "Exhibitor",
    });
    const success = ref(null);
    const error = ref(null);

    onMounted(() => {
      if (props.data) {
        form.value.id = props.data.id;
        form.value.name = props.data.name;
        form.value.name_en = props.data.name_en;
        form.value.email = props.data.email;
        form.value.phone_number = props.data.phone_number;
        form.value.user_type = props.data.user_type;
      }
    });

    const resetForm = () => {
      form.value = {
        id: null,
        name: null,
        name_en: null,
        email: null,
        phone_number: null,
        user_type: "Exhibitor",
      };
    };

    const isValid = () => {
      if (!form.value.name) return alert("Нэр оруулна уу");
      if (!form.value.name_en) return alert("Нэр англиар оруулна уу");
      if (!form.value.email) return alert("Цахим шуудан оруулна уу");
      if (!form.value.user_type) return alert("Төрөл сонгоно уу");

      return true;
    };

    const addUser = async () => {
      if (!isValid()) return;

      try {
        let res;

        if (form.value.id) {
          res = await adminInstance.post(
            "/yellow-page/update/meeting-user",
            form.value
          );
        } else {
          res = await adminInstance.post(
            "/yellow-page/insert/meeting-user",
            form.value
          );
        }

        if (res.status === 200 && res.data.user) {
          success.value = "Амжилттай шинэчлэгдлээ.";
          resetForm();
          setTimeout(() => {
            success.value = null;
          }, 3000);
        } else {
          error.value = res.data.message;
          setTimeout(() => {
            error.value = null;
          }, 3000);
        }
      } catch (err) {
        error.value = "Алдаа гарлаа.";
        setTimeout(() => {
          error.value = null;
        }, 3000);
      }
    };

    return { form, addUser, success, error, closeEdit, isRoute };
  },
};
</script>
